import React, { useContext, useEffect, useState } from 'react'
import { CCard } from '@coreui/react'
import moment from 'moment'
import { getThumbnail } from '../../utils/helper'
import { GlobalContext } from '../../context/GlobalState'
import useAxios from 'axios-hooks'
import { CUSTOM_FORM_ANALYTICS } from '../../utils/urls'
import { AppContext } from '../../context/app'
import { isEmpty } from 'lodash'
import AssetFilter from '../AssetManager/AssetFilter'
import FormListCard from './formListCard'
import { Link } from 'react-router-dom'

const CustomFormAnalytics = () => {
  const [formData, setFormData] = useState([])
  const [searchText, setSearchText] = useState('')
  const { userSessionObj } = useContext(GlobalContext)
  const { setLoader } = useContext(AppContext)

  let entityNameObj = {
    ARTIST_DETAIL: 'Artist Detail page',
    ARTIST_LIST: 'Artist listing page',
    CATEGORY: 'Category landing page',
    PAGES: 'Custom Pages',
    CONTENT_DETAIL: 'Content Detail Page',
    CONTENT_DETAIL_PLAYER: 'Content Detail Page & Player',
    PLAYER: 'Only Player',
    LOGIN: 'Log-in page',
    REGISTER: 'Register Page',
    HOME: 'Home Page',
    IPTV: 'IPTV Channel',
    ALL_IPTV: 'All IPTV Channels',
    PRICING: 'Pricing Page',
    VENUE_DETAIL: 'Venue Detail page',
    VENUE_LIST: 'Venue listing page',
  }

  const [{ data: formList, loading: formListLoading }, formListCall] = useAxios(
    {
      url: CUSTOM_FORM_ANALYTICS,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    formListCall()
  }, [])

  useEffect(() => {
    setLoader(formListLoading)
  }, [formListLoading])

  useEffect(() => {
    if (formList && formList.success) {
      setFormData(formList.data)
    }
  }, [formList])

  const handleSearch = (value) => {
    setSearchText(value)
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h4 style={{ fontSize: '1.5625vw' }} className="font-bold">
            Custom Forms Analytics
          </h4>
          <p>Following are the Custom Forms which are already in your store.</p>
        </div>
      </div>
      <div
        className="d-flex justify-content-center align-items-center "
        style={{
          padding: '1.42vw 0vw 0',
          margin: '0 auto 3vh',
          width: '100%',
        }}
      >
        <div>
          <AssetFilter
            onSearch={handleSearch}
            dropdownHeight={'300px'}
            disableFilter={true}
            searchStyle={{ background: '#fff' }}
          />
        </div>
      </div>
      <CCard style={{}} className="">
        <div>
          <div id="" className="asset-manager-card position-relative">
            <div
              className="d-flex px-2 justify-content-center align-items-center w-100 bg-black text-white position-absolute"
              style={{
                fontSize: 'max(0.63vw,10px)',
                // gap: '0 2.2%',
                paddingTop: '2px',
                paddingBottom: '2px ',
                top: '0',
                zIndex: '10',
              }}
            >
              <div style={{ marginBlockEnd: '0', width: '10%' }} className="text-center mx-2" />
              <div style={{ width: '90%' }} className="d-flex align-items-center">
                <div style={{ marginBlockEnd: '0', width: '36%' }}>Form Name</div>
                <div style={{ marginBlockEnd: '0', width: '19%' }}>Created on</div>
                <div style={{ marginBlockEnd: '0', width: '19%' }}>Placement</div>
                <div style={{ marginBlockEnd: '0', width: '12%' }}>Status</div>
                <div style={{ width: '14%' }}># Responses</div>
              </div>
            </div>
            <div style={{ height: '65vh' }} className="static-scrollbar-class">
              <div
                className="d-flex flex-wrap "
                style={{
                  gap: '1.2vw 0',
                  padding: '30px 8px 20px 8px',
                }}
              >
                {!isEmpty(formData)
                  ? [...formData]
                      .filter((data) =>
                        searchText.trim().length
                          ? data.name.toLowerCase().includes(searchText.toLowerCase())
                          : true,
                      )
                      .map((info, index) => {
                        return (
                          <FormListCard
                            cardImage={getThumbnail(
                              userSessionObj.session_data.cf_domain_name,
                              info?.thumbnail?.s3_key,
                            )}
                            textData={[
                              {
                                name: (
                                  <Link
                                    style={{ color: '#0470f1' }}
                                    to={`/custom-forms/analytics/${info._id}`}
                                  >
                                    {info?.name}
                                  </Link>
                                ),
                                styles: {
                                  overflow: 'hidden',
                                  fontSize: '14px',
                                  width: '36%',
                                },
                              },
                              {
                                name: moment(info?.created_date).format('DD MMM YYYY'),
                                styles: { width: '19%' },
                              },
                              {
                                name: entityNameObj[info?.entities?.type],
                                styles: { width: '19%' },
                              },
                              {
                                name: info?.status ? 'Active' : 'Disable',
                                styles: { width: '12%' },
                              },
                              {
                                name: (
                                  <Link
                                    style={{ color: '#0470f1' }}
                                    to={`/custom-forms/analytics/${info._id}`}
                                  >
                                    {info?.total}
                                  </Link>
                                ),
                                styles: { width: '14%' },
                              },
                            ]}
                            key={index}
                            disableStatus={true}
                            actionButtonOptions={[]}
                          />
                        )
                      })
                  : null}
              </div>
            </div>
          </div>
        </div>
      </CCard>
    </>
  )
}

export default CustomFormAnalytics
